import Konva from "konva";
import Helpers from "../../Helpers";
import ConfiguratorData from "../ConfiguratorData";

class Pillows {

  /**
   * Create new popup on canvas
   * @param {ConfiguratorCanvas} configurator.
   * */
  constructor(configurator) {

    this.helpers = new Helpers(); /*Экземпляр хэлперов*/
    this.configData = new ConfiguratorData();/*Общее хранилище данных*/
    this.configurator = configurator;/*Экземпляр конфигуратора*/

    this.group = new Konva.Group({
      x: 0,
      y: 0,
      width: configurator.containerWidth,
      height: configurator.containerHeight,
      listening: false,
      draggable: false
    });

    /*Лоадер для опций*/
    this.$loaderOptions = $('.options__title .js-ajax-loader');

    /*Масштаб картинок*/
    this.scale = 0.3;

    this.position = {
      x: 0,
      y: 0,
    };

    /*Размер картинок*/
    this.imageSize = 1400;

    /*Нарисован ли*/
    this.isDrawn = false;

    // listen options
    this.debug = (window.location.hash === '#debug');

  }

  /**
   * Получить пути к рендерам подушек
   * @param $item {jQuery} - jQuery объект
   * @param configurator {ConfiguratorCanvas} - ConfiguratorCanvas объект
   * */
  getPillows($item, configurator) {

    let object = this;

    let noPillowAlert = $('.no-pillow-alert--canvas')

    let materialName = $item.data('material-name');
    let materialColor = $item.data('material-color');
    let materialTypeId = $item.data('material-type-id');
    let materialTypeName = $item.data('material-type-name');
    let modules_num = configurator.sofa.state.map((item) => {
      return item.id;
    });

    $.ajax({
      url: ajaxurl,
      dataType: 'json',
      type: 'post',
      data: {
        action: 'get_pillows',
        postId: configurator.sofa.currentSofa,
        materialName: materialName,
        materialColor: materialColor,
        materialTypeId: materialTypeId,
        materialTypeName: materialTypeName,
        modules: modules_num
      },

      beforeSend: () => {
        noPillowAlert.hide()
        configurator.$loaderOptions.removeClass('d-none');
      },

      success: (response) => {

        object.configurator.sofa.sections.forEach((item, index) => {
          let responseItem = response.modules[0][index];
          item.image.front.pillow = responseItem.image.front.pillow
          item.image.back.pillow = responseItem.image.back.pillow
          item.image.frontRight.pillow = responseItem.image.frontRight.pillow
          item.image.frontLeft.pillow = responseItem.image.frontLeft.pillow
          item.image.front.pillowImg = null
          item.image.back.pillowImg = null
          item.image.frontRight.pillowImg = null
          item.image.frontLeft.pillowImg = null
        })

        // console.log('Pillows response', response);

        if(response.successful_material_change === false) {
          object.configurator.materialPillowAvailable = false;

          if(object.configurator.materialAvailable) {
            object.$loaderOptions.addClass('d-none');

            noPillowAlert.show()

            noPillowAlert.find('.close').on('click', () => {
              noPillowAlert.hide()
            })

            object.destroyPillows()
          }
        }
        else {
          object.configurator.materialPillowAvailable = true;
        }

        object.configurator.loadImages(object.configurator.sofa.sections, this.changeMaterialPillow);
      },

      complete: () => {
        configurator.$loaderOptions.addClass('d-none');
      }
    });
  }

  /**
   * Показать подушки
   * */
  showPillows($item) {
    this.getPillows($item, this.configurator)
  }

  /**
   * Построение подушек
   * */
  buildPillows() {
    this.configurator.sofa.rebuild();

    this.isDrawn = true;
  }

  /*Убрать подушки*/
  destroyPillows() {

    this.group.removeChildren()
    this.configurator.layer.draw();
    this.isDrawn = false;
  }

  /**
   * change pillows material or draw them
   */
  changeMaterialPillow(object) {

    if(object.isDrawn) {
      object.sofa.state.forEach(function (item, index) {
        let images = object.layer.find('.image-pillow-' + item.id);

        images.forEach(function (image, img_index) {
          image.image(object.sofa.sections[item.id]['image'][image.info.position]['pillowImg'])
        })
      });

      object.layer.draw();
    }
    else {
      object.pillows.buildPillows()
      object.layer.draw()
    }

    object.$loaderOptions.addClass('d-none');
  }
}

export default Pillows;
